export default "__VITE_ASSET__CNTn7$Yl__"